export default "__VITE_ASSET__CW8ZE6vX__"